export default __webpack_public_path__ + "static/GarySayler-686d9522edc635f1ff8067358f4e88a5.jpg";